import { commonErrorParser, ParsedApiError } from '@summer/react-kit';
import { message } from 'antd';
import { fold } from 'fp-ts/lib/Option';
import Axios, { AxiosError } from 'axios';
import { showError } from 'common/components/ErrorNotification';
import { htmlDecode } from 'lib/dom';

const showErrorMessages = (errors: ParsedApiError[]) =>
  errors.forEach((e) =>
    fold<Array<{ name: string; message: string }>, void>(
      () => message.error(htmlDecode(e.message)),
      (fieldErrors) =>
        fieldErrors.forEach((fe) =>
          message.error(
            `${fe.name ? `Field ${fe.name} has error ` : ''}${htmlDecode(
              fe.message
            )}`
          )
        )
    )(e.fields)
  );

const hasUndefinedError = (errors: ParsedApiError[]) =>
  errors.find((x) => 'UNKNOWN' === x.error);

export const summerErrorHandler = (axiosError: AxiosError) => {
  const parsedErr = Axios.isCancel(axiosError)
    ? undefined
    : commonErrorParser(axiosError.response?.data);
  if (parsedErr !== undefined && !hasUndefinedError(parsedErr)) {
    showErrorMessages(parsedErr);
  } else {
    showError(
      'Error details',
      'Please try again, and if the problem persists, contact technical support and attach error specified below.'
    )({
      url: axiosError.config.url,
      method: axiosError.config.method,
      params: axiosError.config.params,
      data: axiosError.config.data,
      message: axiosError.message,
      parsed: parsedErr,
    });
  }

  return Promise.reject(parsedErr);
};
